import React from "react";
import LeftPipe from "../components/LeftPipe";
import ImageCircle from '../components/ImageCircle';
import Quote from '../components/Quote';
import cynthia from '../assets/photos/headshots/m-headshot-cynthia.png';
import image7 from '../assets/elements/bubble/Bubble-image-7.png';
export default ({ isActive }) => {
  const message = 'Negative trials have great value. They tell us what road not to go down. They’re part of the scientific process and research. If I participate in a clinical trial that’s negative, I don’t feel I’ve wasted my time. I feel as though I’ve helped science focus.”';
  const quote = {
    author: 'Cynthia Chauhan',
    position: 'Clinical trial participant and patient advocate in the United States',
    img: cynthia,
    quote: [message]
  }
  return (
    <div className="component hide-overflow absolute-comp">
      {isActive && (
        <>
        <ImageCircle imgSrc={image7} position={'top'} />
        <LeftPipe />
        </>
      )}
      <Quote quote={quote} position={'center'}/>
    </div>
  );
};
